import getFileBlob from './getFileBlob';

const downloadFileForIEOrEdge = (href, filename) => {
  const blob = getFileBlob(href);

  window.navigator.msSaveOrOpenBlob(blob, filename);
};

export default downloadFileForIEOrEdge;
